module.exports = __webpack_public_path__ + "img/service_image1.4ba09706.jpg";